var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkPackageSubPageModule',{attrs:{"workpackage":_vm.workpackage,"isMobile":_vm.isMobile,"location":_vm.location,"loading":_vm.loading,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex,"header_icon":_vm.$store.state.Ultra.step_icons[_vm.step_type.toLowerCase()],"header_text_short":_vm.$t(`WorkpackageRework.Steps.Types.${_vm.step_type}`),"header_text_long":_vm.$t(`WorkpackageRework.Steps.Types.${_vm.step_type}`) + '.' + _vm.$t(`WorkpackageRework.Steps.steps`)},on:{"headerBack":function($event){return _vm.$router.push({name: `${_vm.location}WorkPackageInfo`, params: { nav_back: _vm.$route.params.nav_back} })}},scopedSlots:_vm._u([{key:"header-rightside",fn:function(){return [(_vm.isEditMode)?_c('TTooltip',{attrs:{"value":_vm.getProjectTooltip({project_id: _vm.project_id, action: 'Add', entity: `${_vm.step_type} Steps`, twp: _vm.workpackage.id})}},[_c('v-btn',{attrs:{"disabled":!_vm.hasProjectPermissionForTWP({project_id: _vm.project_id, action: 'Add', entity: `${_vm.step_type} Steps`, twp: _vm.workpackage.id}),"icon":"","color":_vm.workpackage_fg_hex},on:{"click":function($event){return _vm.$router.push({
          name: `${_vm.location}WorkPackage${_vm.step_type}StepsDetails`,
          params: {
            content_id: 'create',
            nav_back: _vm.$route.params.nav_back,
          }
        })}}},[_c('TIcon',{attrs:{"name":"sign-plus"}})],1)],1):_vm._e()]},proxy:true},{key:"header-slot",fn:function(){return [(_vm.step_type === 'Work')?_c('div',{staticClass:"d-flex header-slot-total",style:(`color: ${_vm.transparent_color}`)},[_c('TIcon',{attrs:{"name":"speedometer","color":_vm.transparent_color,"small":""}}),_vm._v(" "+_vm._s(_vm.calcAllWorkStepsTotal({workpackage: _vm.workpackage, prefix: _vm.prefix}).value)+" mh ")],1):_vm._e()]},proxy:true},{key:"body",fn:function(){return [_c('StepPageStepList',{staticStyle:{"width":"100%"},attrs:{"steps":_vm.steps,"step_type":_vm.step_type,"prefix":_vm.prefix,"backlog":_vm.backlog,"has_lines":true,"background_color":_vm.workpackage_bg_hex,"foreground_color":_vm.workpackage_fg_hex,"isEditMode":_vm.isEditMode,"wp":_vm.workpackage},on:{"clickStepList":function($event){return _vm.$router.push({
        name: `${_vm.location}WorkPackage${_vm.step_type}StepsDetails`,
        params: {
          content_id: $event,
          nav_back: _vm.$route.params.nav_back,
        }
        })},"clickStepDone":function($event){_vm.updateUObject({
        url: _vm.getStepUrl(_vm.step_type, $event.step_id),
        update: {
          [_vm.step_type === 'Material'?'status':'done']: $event.set_to
        }
        }),
        _vm.location === 'ProjectWallet'?
        _vm.updateStepCardStatus({
          project_id: _vm.project_id,
          step_id: $event.step_id,
          step_type: _vm.step_type.toLowerCase(),
          done: $event.set_to,
          offset: $event.step.offset,
          /* offset: step_card.offset,
          wallet_column: wallet_column, */
          }).then(() => {
            _vm.increaseUpdateKeyStepCard();
            })
          :''},"draggableEnd":function($event){$event.newIndex - $event.oldIndex !== 0?
        (
        _vm.backlog?
          _vm.updateUObjectPosition({
            url: _vm.getStepUrl(_vm.step_type, _vm.workpackage[`${_vm.histprefix}${_vm.prefix}${_vm.step_type.toLowerCase()}steps`][$event.oldIndex]),
            update: {
              position: $event.newIndex - $event.oldIndex
            }
          })
        :
        _vm.requestSnackbarUpdatePosition({
          url: _vm.getStepUrl(_vm.step_type, _vm.workpackage[`${_vm.histprefix}t${_vm.step_type.toLowerCase()}steps`][$event.oldIndex]),
          update: {
            position: $event.newIndex - $event.oldIndex
          },
          selector: 'parent',
          limit_selector: true
        }).then((payload) => {
          _vm.updateUObjectPosition(payload)
        })
        )
        :
        ''}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }